import React from "react";
import { motion } from "framer-motion";

// Cinematic exterior repaint reveal: an old, worn paint job transforms into a
// beautiful fresh paint job over ~5 seconds, then holds and gently loops.
// A glowing gold "wet paint" edge tracks the wipe to sell the transformation.
export default function PaintReveal() {
  const times = [0, 0.12, 0.57, 0.9, 1]; // reveal happens 0.12 -> 0.57 (~5s of an 11s loop)
  const duration = 11;

  return (
    <div className="absolute inset-0 overflow-hidden bg-black" data-testid="paint-reveal">
      {/* AFTER (freshly painted) — base layer */}
      <img
        src="/gallery/home_after.jpg"
        alt="Freshly painted luxury home exterior"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ filter: "saturate(1.1) contrast(1.04) brightness(1.02)" }}
        data-testid="paint-after"
      />

      {/* BEFORE (old dated paint) — on top, wipes away to reveal the AFTER */}
      <motion.img
        src="/gallery/home_before.jpg"
        alt="Home exterior with old dated paint"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="paint-before"
        initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
        animate={{
          clipPath: [
            "inset(0% 0% 0% 0%)",
            "inset(0% 0% 0% 0%)",
            "inset(0% 100% 0% 0%)",
            "inset(0% 100% 0% 0%)",
            "inset(0% 0% 0% 0%)",
          ],
        }}
        transition={{ duration, times, ease: "easeInOut", repeat: Infinity }}
      />

      {/* Glowing gold "wet paint" edge that tracks the wipe */}
      <motion.div
        className="absolute top-0 bottom-0 w-[3px] pointer-events-none"
        style={{
          background: "linear-gradient(to bottom, rgba(255,240,200,0), rgba(255,225,150,0.95), rgba(255,240,200,0))",
          boxShadow: "0 0 26px 8px rgba(214,164,65,0.7)",
        }}
        initial={{ left: "0%", opacity: 0 }}
        animate={{
          left: ["0%", "0%", "100%", "100%", "0%"],
          opacity: [0, 1, 1, 0, 0],
        }}
        transition={{ duration, times, ease: "easeInOut", repeat: Infinity }}
      />

      {/* Legibility scrims for the hero copy */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(to top, rgba(5,5,5,0.85) 0%, rgba(5,5,5,0.25) 40%, rgba(5,5,5,0.35) 100%)" }} />
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(120% 90% at 50% 45%, rgba(5,5,5,0) 30%, rgba(5,5,5,0.55) 100%)" }} />
    </div>
  );
}
